import { FC, useEffect } from 'react';

import { BrowserRouter } from 'react-router-dom';

import { Private } from 'routes/private';

export const Routes: FC = () => {
  // ユーザーエージェントがAndroidを示している場合、body要素に'android'のデータ属性を設定します
  useEffect(() => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua) || ua.indexOf('Android') > 0) {
      document.body.dataset.model = 'android';
    }
  }, []);

  return (
    <BrowserRouter>
      <Private />
    </BrowserRouter>
  );
};
